import { Icon } from "@/components/icon";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SIZE } from "@/configs/sizes";
import { IconComponent } from "@/icons";
import { cn } from "@/utils/class-name";

interface WarningPopoverProps {
    title: string;
    icon: IconComponent;
    description: React.ReactNode;
    triggerClassName?: string;
}
export function WarningPopover({ title, description, icon, triggerClassName }: WarningPopoverProps) {
    return (
        <Popover>
            <PopoverTrigger
                openOnHover
                className={cn("flex w-fit flex-row gap-2 items-center border-1 rounded-md p-2", triggerClassName)}
            >
                <Icon icon={icon} size={SIZE.XS} iconClassName={"text-inherit"} />
                <h3 className={"text-xs xs:text-sm text-start"}>{title}</h3>
            </PopoverTrigger>
            <PopoverContent className={"max-w-sm"}>
                <div className={"text-sm"}>{description}</div>
            </PopoverContent>
        </Popover>
    );
}
